import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../imageWithBasePath'
import { all_routes } from '../../../feature-module/router/all_routes'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* Footer */}
      <footer className="footer">
        <div className="footer-bg">
          <ImageWithBasePath
            src="assets/img/bg/footer-bg-01.png"
            className="footer-bg-1"
            alt=""
          />
          <ImageWithBasePath
            src="assets/img/bg/footer-bg-02.png"
            className="footer-bg-2"
            alt=""
          />
        </div>
        <div className="footer-top">
          <div className="container">
            <div className="row row-gap-4">
              <div className="footer-logo">
                <ImageWithBasePath src="assets/img/logo_cyber.png" alt="" width={100}/>
              </div>
              <div className="col-lg-7">
                <div className="footer-about">
                  <h6>{t('footer.about.title')}</h6><br />
                  <p className='col-11'>
                    {t('footer.about.description')}
                  </p>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="row row-gap-4">
                  <div className="col-lg-12">
                    <div className="footer-widget footer-contact">
                      <h6 className="footer-title mb-4">{t('footer.company.name')}</h6>
                      <div className="footer-contact-info">
                        <div className="footer-address d-flex align-items-center">
                          <ImageWithBasePath
                            src="assets/img/icon/icon-20.svg"
                            alt="Img"
                            className="img-fluid me-2"
                          />
                          <p>{t('footer.company.address')}</p>
                        </div>
                        <div className="footer-address d-flex align-items-center">
                          <ImageWithBasePath
                            src="assets/img/icon/icon-19.svg"
                            alt="Img"
                            className="img-fluid me-2"
                          />
                          <p>{t('footer.company.email')}</p>
                        </div>
                        <div className="footer-address d-flex align-items-center">
                          <ImageWithBasePath
                            src="assets/img/icon/icon-21.svg"
                            alt="Img"
                            className="img-fluid me-2"
                          />
                          <p>{t('footer.company.phone')}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer